import type { LocationInfoProps } from "./location-info.type";

import { Divider, Space } from "antd";
import { useTranslation } from "react-i18next";

import { getOrganizationAncestor } from "@/entities/ancestor";
import { isSector as isSectorFn } from "@/entities/location";
import { ButtonCopy } from "@/modules/button-copy";
import {
  FlexContainerText,
  FlexContainerJsx,
  FlexContainerImage,
} from "@/modules/flex-container";
import LocationBreadcrumb from "@/modules/location/location-breadcrumb";
import { LocationMapSimple } from "@/modules/location/location-map-simple";
import { stringify } from "@/utilities/json";

const Info = ({ location }: LocationInfoProps) => {
  const { t } = useTranslation();
  const isSector = isSectorFn(location);

  const { description, ancestors, coordinate, photo, geographical_data } =
    location;
  const organization = getOrganizationAncestor(ancestors);

  const geojson = stringify(geographical_data);

  return (
    <>
      <Space orientation="vertical" size="middle">
        {description && (
          <FlexContainerText
            value={description}
            label={t("location:form.description.label")}
          />
        )}
        {organization && (
          <FlexContainerText
            value={organization.name}
            label={t("global:organization")}
            link={`/organizations/${organization.id}`}
          />
        )}
        {isSector && (
          <FlexContainerJsx
            value={
              <LocationBreadcrumb
                location={location}
                exclude={["organization"]}
              />
            }
            label={t("global:hierarchy")}
          />
        )}
        {coordinate && (
          <FlexContainerJsx
            label={t("global:coordinate.label")}
            noWrapper
            value={
              <LocationMapSimple location={location} context="location_info" />
            }
            fullWidth
          />
        )}
        {geojson && (
          <FlexContainerJsx
            label={t("global:geojson.label")}
            value={<ButtonCopy data={geojson} />}
          />
        )}
        {photo && (
          <FlexContainerImage
            label={t("location:form.photo.label")}
            document={photo}
          />
        )}
      </Space>
      <Divider />
    </>
  );
};

export default Info;
